import React, { useState, useEffect } from 'react';
import { ShieldCheck, LockKeyhole, UserRound } from 'lucide-react';
import getClientConfig from '../config';

const { API_BASE_URL } = getClientConfig();



export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    document.title = "Login | IP Portal";
  }, []);

  const handleLogin = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setErrorMsg(data.error || 'Login failed');
        return;
      }

      localStorage.setItem('auth_token', data.token);
      window.location.href = '/dashboard';
    } catch (err) {
      setErrorMsg('Login failed. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl p-8 shadow-lg relative z-10">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-100 p-4 rounded-full shadow-inner ring-2 ring-blue-400">
          <ShieldCheck className="h-8 w-8 text-blue-500" />
        </div>

        <div className="text-center mt-6 mb-10">
          <h1 className="text-3xl font-bold text-gray-800 tracking-widest uppercase">IP Portal Login</h1>
          <p className="text-xs text-gray-500 mt-1">Network Intelligence Access Panel</p>
        </div>

        <form className="space-y-5" onSubmit={(e) => e.preventDefault()}>
          <div>
            <label htmlFor="email" className="block text-xs font-semibold text-gray-600 uppercase mb-1">Email</label>
            <div className="relative">
              <UserRound className="absolute left-3 top-2.5 text-gray-400 w-4 h-4" />
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter email"
                className="pl-10 w-full px-4 py-2 bg-white text-gray-800 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
              />
            </div>
          </div>

          <div>
            <label htmlFor="password" className="block text-xs font-semibold text-gray-600 uppercase mb-1">Password</label>
            <div className="relative">
              <LockKeyhole className="absolute left-3 top-2.5 text-gray-400 w-4 h-4" />
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="pl-10 w-full px-4 py-2 bg-white text-gray-800 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none"
              />
            </div>
          </div>

          {errorMsg && (
            <p className="text-sm text-red-500 text-center">{errorMsg}</p>
          )}

          <button
            type="submit"
            onClick={handleLogin}
            className="w-full py-2 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg shadow-md transition duration-200 tracking-wider text-sm uppercase"
          >
            Authenticate
          </button>
        </form>

        <div className="mt-10 text-center text-[11px] text-gray-400 border-t border-gray-200 pt-4">
          <p>&copy; {new Date().getFullYear()} GOSOFT LAB</p>
          <p className="uppercase tracking-wide text-blue-500 mt-1">Unauthorized Attempts are Logged and Reported</p>
        </div>
      </div>
    </div>
  );
}
